import React, { FC } from 'react';

import styled from '@emotion/styled';
import {
    ActionItem,
    ActionItemSkeleton,
    ActionItemSkeletonProps,
    ActionProps,
} from 'src/shared/ds/components/ActionItem';
import {
    SectionHeader,
    SectionHeaderSkeleton,
    SectionHeaderSkeletonProps,
} from 'src/shared/ds/components/SectionHeader';

export interface ActionPropsWithId extends ActionProps {
    id: string;
}

interface ActionListProps {
    actions: ActionPropsWithId[];
    title?: string;
    secondaryText?: string;
    onSecondaryTextPress?: () => void;
    containerClassName?: string;
}

export const ActionItemList: FC<ActionListProps> = ({
    actions,
    title,
    secondaryText,
    onSecondaryTextPress,
    containerClassName,
}) => {
    return (
        <Container className={containerClassName}>
            {title && (
                <SectionHeader
                    title={title}
                    secondaryText={secondaryText}
                    onSecondaryTextPress={onSecondaryTextPress}
                    noMarginTop
                />
            )}
            {actions.map(action => (
                <ActionItem key={action.id} {...action} />
            ))}
        </Container>
    );
};

interface ActionItemListSkeletonProps extends SectionHeaderSkeletonProps {
    actions: ActionItemSkeletonProps[];
}

export const ActionItemListSkeleton: React.FC<ActionItemListSkeletonProps> = ({
    actions,
    showSecondaryButton,
}) => (
    <Container>
        <SectionHeaderSkeleton showSecondaryButton={showSecondaryButton} noMarginTop />
        {actions.map((action, i) => (
            <ActionItemSkeleton
                key={i} // there is nothing else that can be used as a key but index in this specific case should be ok
                hideIcon={action.hideIcon}
                hideDescription={action.hideDescription}
            />
        ))}
    </Container>
);

const Container = styled.div({
    flex: 1,
});
